import { View, Text } from "@react-pdf/renderer";
import RulerPDF from "./RulerPDF.jsx";
import PositionPDF from "./PositionPDF.jsx";

export default function SubstitutionChartPDF({ rotation }) {
  const { periodLength, periods, positionLabels } = rotation;

  let availablePeriods = periods === 2 ? [1, 2] : [1, 2, 3, 4];

  let cordinal = ["st", "nd", "rd", "th"];

  return (
    <View
      style={{
        marginLeft: "20px",
      }}
    >
      {availablePeriods.map((period) => (
        <View
          key={period}
          style={{
            marginBottom: "15px",
          }}
        >
          <View style={{ marginBottom: "10px" }}>
            <Text style={{ fontSize: 10,fontWeight:700, textAlign: "center" }}>
              {`${period}${cordinal[period - 1]} ${
                periods === 2 ? "Half" : "Quarter"
              }`}
            </Text>
          </View>
          <RulerPDF start={0} end={periodLength} />
          {[0, 1, 2, 3, 4].map((position) => (
            <PositionPDF
              key={position}
              rotation={rotation}
              editable={false}
              period={period}
              start={periodLength * (period - 1)}
              end={periodLength * period}
              position={position}
              positionLabels={positionLabels}
            />
          ))}
        </View>
      ))}
    </View>
  );
}
